import {flatten, merge} from 'lodash';
import {getBaseURL, nil} from '@/common';
import axios from 'axios';
import {DateTime, IANAZone} from 'luxon';

const supportsNoPagination = ['Booking', 'VendorClaim'];
export function serviceAsDataLayerProduct(service: any, quantity=1){
  return {
    id:service._id.toString(),
    name:service.name,
    category: service.categoryModel.name,
    variant: service.tierModel.name,
    quantity,
    price: service.price.toFixed(2),
  }
}
export async function FeathersVuexFindAll(service: any, findOptions: any, disablePaginationWherePossible = false) {
  if (supportsNoPagination.indexOf(service.className) > -1 && disablePaginationWherePossible) {
    return FeathersVuexFindAllNonPaginated(service, findOptions);
  }
  if (nil(findOptions.query)) {
    findOptions.query = {};
  }
  const totalQuery = Object.assign({}, findOptions);
  totalQuery.query.$limit = 0;
  const { total } = await service.find(findOptions);
  const $limit = 50;
  const results: any[] = [];
  const pages = Math.ceil(total / $limit);
  let currentPage = 0;
  for (let i = 0; i < pages; i++) {
    const $skip = $limit * i;
    const { data } = await service.find(
      merge(findOptions, {
        query: {
          $limit,
          $skip,
        },
      }),
    );
    results.push(data);
    currentPage++;
  }
  return flatten(results);
}

async function FeathersVuexFindAllNonPaginated(service: any, findOptions: any) {
  if (nil(findOptions.query)) {
    findOptions.query = {};
  }
  findOptions.query.$limit = -1;
  return service.find(findOptions);
}

export async function FeathersVuexFindOne(service: any, findOptions: any) {
  if (nil(findOptions.query)) {
    findOptions.query = {};
  }
  findOptions.query.$limit = 1;
  const query = await service.find(findOptions);
  if (query.total === 0) {
    return undefined;
  } else if (query.total === 1) {
    return query.data[0];
  } else {
    throw Error('Could not find 1');
  }
}
export async function AxiosFindAll(serviceName: string) {
  const url = `${getBaseURL()}/${serviceName}`;
  const headers = {Accept: 'application/json'};
  try {
    const config = {
      method: 'GET',
      headers,
      params: {$limit: 0},
    };
    const response = await axios.get(url, config);
    console.log(response);
  } catch (e) {
  }
}

export function getZonedBookingDate(booking: any) {
  return nil(booking.localizedDate) ? DateTime.fromISO(booking.date).toLocal() : DateTime.fromISO(booking.localizedDate, {setZone: true});
}
